import { Response } from 'shared/models/general'

import { PublicOfferModel } from './PublicOfferModel'
import { clientApi } from './clientApi'

export const PublicOfferApi = {
  getOffers(signal?: AbortSignal) {
    return clientApi.get<Response<PublicOfferModel[]>>('/public-offer', {
      signal,
    })
  },
}
